import { ART_DECO_2_BACKGROUND_IMAGE_URL, ART_DECO_3_BACKGROUND_IMAGE_URL, ART_DECO_BACKGROUND_IMAGE_URL, BLOBS_2_BACKGROUND_IMAGE_URL, BLOBS_2_THUMB_IMAGE_URL, BLOBS_3_BACKGROUND_IMAGE_URL, BLOBS_3_THUMB_IMAGE_URL, BLOBS_BACKGROUND_IMAGE_URL, BLOBS_THUMB_IMAGE_URL, BRICKS_2_BACKGROUND_IMAGE_URL, BRICKS_3_BACKGROUND_IMAGE_URL, BRICKS_4_BACKGROUND_IMAGE_URL, BRICKS_BACKGROUND_IMAGE_URL, CONCENTRIC_BACKGROUND_IMAGE_URL, CONCRETE_BACKGROUND_IMAGE_URL, FOLDS_2_BACKGROUND_IMAGE_URL, FOLDS_BACKGROUND_IMAGE_URL, MOON_BACKGROUND_IMAGE_URL, OLIVES_BACKGROUND_IMAGE_URL, PAISLEY_BACKGROUND_IMAGE_URL, SLATE_BACKGROUND_IMAGE_URL, SPACE_BACKGROUND_IMAGE_URL, SQUARES_BACKGROUND_IMAGE_URL, TECHNOLOGY_BACKGROUND_IMAGE_URL, TRUCHET_2_BACKGROUND_IMAGE_URL, TRUCHET_BACKGROUND_IMAGE_URL, WOOD_2_BACKGROUND_IMAGE_URL, WOOD_BACKGROUND_IMAGE_URL, ZIGZAG_BACKGROUND_IMAGE_URL } from '../assets/themeBackgroundAssetUrls';
export const ALL_THEME_BACKGROUND_TYPES = [
    'squares',
    'truchet',
    'truchet2',
    'zigzag',
    'paisley',
    'concentric',
    'olives',
    'slate',
    'moon',
    'space',
    'concrete',
    'technology',
    'wood',
    'wood2',
    'artDeco',
    'artDeco2',
    'artDeco3',
    'blobs',
    'blobs2',
    'blobs3',
    'folds',
    'folds2',
    'bricks',
    'bricks2',
    'bricks3',
    'bricks4'
];
export function isThemeBackgroundType(str) {
    return ALL_THEME_BACKGROUND_TYPES.includes(str);
}
export const DEFAULT_THEME_BACKGROUND_TYPE = 'squares';
export const ALL_THEME_BACKGROUND_PROPERTIES = {
    squares: {
        type: 'squares',
        label: 'Squares',
        renderType: 'tile',
        imageUrl: SQUARES_BACKGROUND_IMAGE_URL,
        backgroundColor: '#1b3443',
        dimensions: { w: 600, h: 600 }
    },
    truchet: {
        type: 'truchet',
        label: 'Truchet',
        renderType: 'tile',
        imageUrl: TRUCHET_BACKGROUND_IMAGE_URL,
        backgroundColor: '#221d31',
        tableShadowAlpha: 0.2,
        dimensions: { w: 600, h: 600 }
    },
    truchet2: {
        type: 'truchet2',
        label: 'Truchet 2',
        renderType: 'tile',
        imageUrl: TRUCHET_2_BACKGROUND_IMAGE_URL,
        backgroundColor: '#5e1b1b',
        tableShadowAlpha: 0.2,
        dimensions: { w: 600, h: 600 }
    },
    zigzag: {
        type: 'zigzag',
        label: 'Zig-Zag',
        renderType: 'tile',
        imageUrl: ZIGZAG_BACKGROUND_IMAGE_URL,
        backgroundColor: '#572826',
        dimensions: { w: 600, h: 600 }
    },
    paisley: {
        type: 'paisley',
        label: 'Paisley',
        renderType: 'tile',
        imageUrl: PAISLEY_BACKGROUND_IMAGE_URL,
        backgroundColor: '#190628',
        tableShadowAlpha: 0.3,
        dimensions: { w: 390, h: 390 }
    },
    concentric: {
        type: 'concentric',
        label: 'Concentric',
        renderType: 'tile',
        imageUrl: CONCENTRIC_BACKGROUND_IMAGE_URL,
        backgroundColor: '#282245',
        tableShadowAlpha: 0.15,
        dimensions: { w: 900, h: 520 }
    },
    olives: {
        type: 'olives',
        label: 'Olives',
        renderType: 'tile',
        imageUrl: OLIVES_BACKGROUND_IMAGE_URL,
        backgroundColor: '#003a1e',
        dimensions: { w: 450, h: 260 }
    },
    slate: {
        type: 'slate',
        label: 'Slate',
        renderType: 'tile',
        imageUrl: SLATE_BACKGROUND_IMAGE_URL,
        backgroundColor: '#1f2022',
        tableShadowAlpha: 0.3,
        dimensions: { w: 600, h: 600 }
    },
    moon: {
        type: 'moon',
        label: 'Moon',
        renderType: 'tile',
        imageUrl: MOON_BACKGROUND_IMAGE_URL,
        backgroundColor: '#33353a',
        tableShadowAlpha: 0.15,
        dimensions: { w: 600, h: 600 }
    },
    space: {
        type: 'space',
        label: 'Space',
        renderType: 'tile',
        imageUrl: SPACE_BACKGROUND_IMAGE_URL,
        backgroundColor: '#0b0515',
        tableShadowAlpha: 0,
        dimensions: { w: 600, h: 600 }
    },
    concrete: {
        type: 'concrete',
        label: 'Concrete',
        renderType: 'tile',
        imageUrl: CONCRETE_BACKGROUND_IMAGE_URL,
        backgroundColor: '#69635a',
        dimensions: { w: 600, h: 600 }
    },
    technology: {
        type: 'technology',
        label: 'Technology',
        renderType: 'tile',
        imageUrl: TECHNOLOGY_BACKGROUND_IMAGE_URL,
        backgroundColor: '#54575b',
        dimensions: { w: 600, h: 600 }
    },
    wood: {
        type: 'wood',
        label: 'Wood',
        renderType: 'tile',
        imageUrl: WOOD_BACKGROUND_IMAGE_URL,
        backgroundColor: '#462c17',
        tableShadowAlpha: 0.25,
        dimensions: { w: 600, h: 600 }
    },
    wood2: {
        type: 'wood2',
        label: 'Wood 2',
        renderType: 'tile',
        imageUrl: WOOD_2_BACKGROUND_IMAGE_URL,
        backgroundColor: '#28241d',
        tableShadowAlpha: 0.3,
        dimensions: { w: 600, h: 600 }
    },
    artDeco: {
        type: 'artDeco',
        label: 'Art Deco 1',
        renderType: 'tile',
        imageUrl: ART_DECO_BACKGROUND_IMAGE_URL,
        backgroundColor: '#0b282c',
        tableShadowAlpha: 0.2,
        dimensions: { w: 600, h: 600 }
    },
    artDeco2: {
        type: 'artDeco2',
        label: 'Art Deco 2',
        renderType: 'tile',
        imageUrl: ART_DECO_2_BACKGROUND_IMAGE_URL,
        backgroundColor: '#f27c32',
        dimensions: { w: 600, h: 600 }
    },
    artDeco3: {
        type: 'artDeco3',
        label: 'Art Deco 3',
        renderType: 'tile',
        imageUrl: ART_DECO_3_BACKGROUND_IMAGE_URL,
        backgroundColor: '#457c9d',
        dimensions: { w: 600, h: 600 }
    },
    blobs: {
        type: 'blobs',
        label: 'Blobs 1',
        renderType: 'cover',
        imageUrl: BLOBS_BACKGROUND_IMAGE_URL,
        thumbnailImageUrl: BLOBS_THUMB_IMAGE_URL,
        backgroundColor: '#171d3d',
        tableShadowAlpha: 0,
        dimensions: { w: 2400, h: 2400 }
    },
    blobs2: {
        type: 'blobs2',
        label: 'Blobs 2',
        renderType: 'cover',
        imageUrl: BLOBS_2_BACKGROUND_IMAGE_URL,
        thumbnailImageUrl: BLOBS_2_THUMB_IMAGE_URL,
        backgroundColor: '#003b2d',
        tableShadowAlpha: 0,
        dimensions: { w: 2400, h: 2400 }
    },
    blobs3: {
        type: 'blobs3',
        label: 'Blobs 3',
        renderType: 'cover',
        imageUrl: BLOBS_3_BACKGROUND_IMAGE_URL,
        thumbnailImageUrl: BLOBS_3_THUMB_IMAGE_URL,
        backgroundColor: '#320027',
        tableShadowAlpha: 0,
        dimensions: { w: 2400, h: 2400 }
    },
    folds: {
        type: 'folds',
        label: 'Folds',
        renderType: 'tile',
        imageUrl: FOLDS_BACKGROUND_IMAGE_URL,
        backgroundColor: '#001248',
        tableShadowAlpha: 0.3,
        dimensions: { w: 600, h: 600 }
    },
    folds2: {
        type: 'folds2',
        label: 'Folds 2',
        renderType: 'tile',
        imageUrl: FOLDS_2_BACKGROUND_IMAGE_URL,
        backgroundColor: '#0a1423',
        tableShadowAlpha: 0.2,
        dimensions: { w: 600, h: 600 }
    },
    bricks: {
        type: 'bricks',
        label: 'Bricks',
        renderType: 'tile',
        imageUrl: BRICKS_BACKGROUND_IMAGE_URL,
        backgroundColor: '#311c13',
        tableShadowAlpha: 0.4,
        dimensions: { w: 600, h: 600 }
    },
    bricks2: {
        type: 'bricks2',
        label: 'Bricks 2',
        renderType: 'tile',
        imageUrl: BRICKS_2_BACKGROUND_IMAGE_URL,
        backgroundColor: '#1d3034',
        tableShadowAlpha: 0.4,
        dimensions: { w: 600, h: 600 }
    },
    bricks3: {
        type: 'bricks3',
        label: 'Bricks 3',
        renderType: 'tile',
        imageUrl: BRICKS_3_BACKGROUND_IMAGE_URL,
        backgroundColor: '#212121',
        tableShadowAlpha: 0.4,
        dimensions: { w: 600, h: 600 }
    },
    bricks4: {
        type: 'bricks4',
        label: 'Bricks 4',
        renderType: 'tile',
        imageUrl: BRICKS_4_BACKGROUND_IMAGE_URL,
        backgroundColor: '#1d172e',
        tableShadowAlpha: 0.4,
        dimensions: { w: 600, h: 600 }
    }
};
